import { RouterProvider } from 'react-router-dom';
import { useEffect } from 'react';
import { Providers } from '@/app/providers';
import { router } from '@/app/router';
import { useAuthStore } from '@/stores/authStore';
import { ErrorBoundary } from '@/components/ErrorBoundary';

export function App() {
  const setLoading = useAuthStore((s) => s.setLoading);

  // On mount, mark loading as complete once hydration from localStorage is done.
  // Zustand persist middleware hydrates synchronously, so by the time
  // this effect runs, the store already has the persisted values.
  useEffect(() => {
    setLoading(false);
  }, [setLoading]);

  return (
    <ErrorBoundary>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </ErrorBoundary>
  );
}
